exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".save-btn {\n  background-color: #2ec58d;\n  border-color: #2ec58d;\n  color: white !important; }\n\n.save-btn:hover, .save-btn:active, .save-btn:focus {\n  background-color: #27a677;\n  border-color: #249c6f; }\n\n#OfferChilds input[type=\"number\"] {\n  padding-right: 40px; }\n", ""]);

// exports
